module.exports = __webpack_public_path__ + "img/Light Rain.bfd89e13.png";